// extracted by mini-css-extract-plugin
export var cardContainer = "_om-0";
export var cardHeader = "_om-2";
export var collapsedState = "_om-3";
export var dragHandle = "_om-5";
export var dragHandleIcon = "_om-6";
export var dragging = "_om-1";
export var titleArea = "_om-4";